import React from "react";

// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Container,
  Row,
  Col,
  Table,
  UncontrolledTooltip,
  CardFooter,
  Button,
  CardTitle,
} from "reactstrap";

// Core Components
import LandingPageNavbar from "../navbars/PageNavbar";
import SiteFooter from "../footers/SiteFooter";

const Runners = () => {
  return (
    <>
      <LandingPageNavbar />

      {/* <LandingPageNavbar type="primary" /> */}
      <section className="section-features bg-secondary">
        <br />
        <Container>
          <Row>
            <Col className="mx-auto" lg="10" md="8">
              <h2 className="title mb-5">Our Awesome Team</h2>
              <Card className="card-blog card-plain blog-horizontal mb-5">
                <Row>
                  <Col lg="4">
                    <div className="card-image shadow">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          alt="..."
                          className="img rounded"
                          src={require("assets/img/faces/Angelo.jpg")}
                        ></img>
                      </a>
                    </div>
                  </Col>
                  <Col lg="8">
                    <CardBody>
                      <CardTitle tag="h3">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          Angelo Adams
                        </a>
                      </CardTitle>
                      <p className="card-description">
                        I talk for a living. <br /> <br />I teach, coach, manage
                        and offer a space for young people to showcase their
                        skills in the sports arena. I'm a dad to a little girl,
                        married to an incredible woman that supports my crazy
                        ideas and an uncle to three nieces who I hope to inspire
                        to do things that assist the less fortunate.
                      </p>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
              <Card className="card-blog card-plain blog-horizontal mb-5">
                <Row>
                  <Col lg="4">
                    <div className="card-image shadow">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          alt="..."
                          className="img rounded"
                          src={require("assets/img/faces/Esmund.jpg")}
                        ></img>
                      </a>
                    </div>
                  </Col>
                  <Col lg="8">
                    <CardBody>
                      <CardTitle tag="h3">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          Esmund van Vyk
                        </a>
                      </CardTitle>
                      <p className="card-description">
                        Teacher, Father, former cricketer and sports coach with
                        a love for running long distances.
                        <br /> <br />
                        My life goal is to leave a legacy my family can be proud
                        of and hopefully follow. Raising funds is simply the
                        right thing for us to do, as we have been given the
                        ability to make that kind of difference.
                      </p>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
              <Card className="card-blog card-plain blog-horizontal">
                <Row>
                  <Col lg="4">
                    <div className="card-image shadow">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          alt="..."
                          className="img rounded"
                          src={require("assets/img/faces/Merlin.jpg")}
                        ></img>
                      </a>
                    </div>
                  </Col>
                  <Col lg="8">
                    <CardBody>
                      <CardTitle tag="h3">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          Merlin Galant
                        </a>
                      </CardTitle>
                      <p className="card-description">
                        I am a medical representative. I am a husband and father
                        of two and an avid sportsman.
                        <br /> <br />
                        My journey with long distance running started as a
                        youngster in high school and I haven't looked back
                        since.
                        <br /> <br />
                        My goal is to teach my boys the value of hardwork,
                        discipline and to help others where they can. This run
                        is an ideal opportunity for me to combine something I am
                        passionate about and to help an organisation that is
                        doing so much to help our kids.
                        <br /> <br />
                        More Importantly, I get to do it with my family and my
                        good mates.
                      </p>
                    </CardBody>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <SiteFooter />
    </>
  );
};

export default Runners;
